/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InfoInputs */

const en_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const fr_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const de_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const it_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const ru_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация`)
};

const es_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const zh_cn2_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ja_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`情報`)
};

const hi_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानकारी`)
};

const pt_pt2_info = /** @type {(inputs: InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações`)
};

/**
* | output |
* | --- |
* | "Info" |
*
* @param {InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const info = /** @type {((inputs?: InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_info(inputs)
	if (locale === "de") return de_info(inputs)
	if (locale === "it") return it_info(inputs)
	if (locale === "ru") return ru_info(inputs)
	if (locale === "es") return es_info(inputs)
	if (locale === "zh-CN") return zh_cn2_info(inputs)
	if (locale === "ja") return ja_info(inputs)
	if (locale === "hi") return hi_info(inputs)
	if (locale === "pt-PT") return pt_pt2_info(inputs)
	return en_info(inputs)
});